// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDz3ZjOqctGGTCz-sZj_eq924vSMen2QN4',
    authDomain: 'm4m-code-heroes-dev.firebaseapp.com',
    databaseURL: 'https://m4m-code-heroes-dev.firebaseio.com',
    projectId: 'm4m-code-heroes-dev',
    storageBucket: 'm4m-code-heroes-dev.appspot.com',
    messagingSenderId: '650318343133',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
